export function savePoll(poll) {
  return {
    type: 'SAVE_POLL',
    poll,
  };
}

export function editPoll(poll) {
  return {
    type: 'EDIT_POLL',
    poll,
  };
}
